import { utcToZonedTime } from "date-fns-tz";
import { format, formatDistanceStrict } from "date-fns";
var ianaTimeZone = window.Intl.DateTimeFormat().resolvedOptions().timeZone;
export function getDateLong(dateValue) {
  if (!dateValue) return dateValue;
  return formatDate({
    dateValue: dateValue,
    formating: "MMMM d, yyyy"
  });
}
export function getDateShort(dateValue) {
  if (!dateValue) return dateValue;
  return formatDate({
    dateValue: dateValue,
    formating: "M/d/yy"
  });
}
export function getDateTime(dateValue) {
  if (!dateValue) return dateValue;
  return formatDate({
    dateValue: dateValue,
    formating: "h:mma"
  });
}
export function getTimeAgo(dateValue) {
  if (!dateValue) return dateValue;
  var timeAgo = formatDistanceStrict(getDateInTimeZone(dateValue), Date.now());
  return timeAgo.includes("seconds") ? "just now" : timeAgo + " ago";
}
export function formatDate(_a) {
  var dateValue = _a.dateValue,
      formating = _a.formating;
  if (!dateValue) return dateValue;
  return format(getDateInTimeZone(dateValue), formating);
}
export function getDateInTimeZone(dateValue) {
  if (!dateValue) return dateValue;
  return utcToZonedTime(dateValue, ianaTimeZone);
}